// Readiness rule for the float32 converted model required by Live Test and
// benchmark evaluations (ESC50, DCASE2018). Mirrors the backend predicate
// ConvertedModel.is_ready_for_inference, enforced by
// ModelManager.ensure_converted_model_exists: upload complete (status 5) and
// the 'all' model completed. TF rows converted before per-model status
// tracking have a null all_status and count as ready.
export const isFp32ConvertedModelReady = (modelMap, isTorch) => {
    if (isTorch) {
        const onnx = modelMap?.onnx_float32;
        return !!(
            onnx &&
            Object.keys(onnx).length > 0 &&
            onnx.status === 5 &&
            onnx.all_status === "completed"
        );
    }
    const pb = modelMap?.pb_float32;
    return !!(
        pb &&
        Object.keys(pb).length > 0 &&
        pb.status === 5 &&
        (pb.all_status == null || pb.all_status === "completed")
    );
};

export const requiredFp32FormatLabel = (isTorch) =>
    isTorch ? "onnx_float32 (all)" : "pb_float32";
